// strips html tags https://stackoverflow.com/questions/5002111/how-to-strip-html-tags-from-string-in-javascript
export const stripHtmlTags = (html: string) => {
  return html.replace(/<\/?[^>]+(>|$)/g, '');
};
